import { DateTime } from 'luxon'

/**
 * @param date date to be formatted
 * @param format custom format date (default: dd/LL/YYYY)
 * @returns string
 */
export function formatDate (date: DateTime, format: undefined | string = 'dd/LL/yyyy') {
  return DateTime.fromISO(date.toString()).toFormat(format)
}